import React, { Suspense } from "react";
import Stepper from "./Components/Stepper";
import { FormContextProvider } from "../../Contexts/FormContextProvider";
import useOptimaSecureCQ from "./useOptimaSecureCQ";
import Loading from "../../Components/Loading";
import CategoryHeader from "./../../../Components/Headers/CategoryHeader";

const OptimaSecureCQ = (props) => {
  const {
    transferData,
    onBack,
    onSubmit,
    finalData,
    loading,
    CurrentStep,
    stepsLabel,
    activeStep,
    handleStepClick,
  } = useOptimaSecureCQ(props);

  return (
    <FormContextProvider
      value={{
        onSubmit,
        onBack,
        values: finalData,
        transferData,
        loading,
      }}
    >
      <CategoryHeader title="Health Insurance" />
      <Stepper
        steps={stepsLabel}
        activeStep={activeStep}
        onClick={handleStepClick}
        disabled={loading}
      />
      <Suspense fallback={<Loading />}>
        <CurrentStep />
      </Suspense>
    </FormContextProvider>
  );
};

export default OptimaSecureCQ;
